import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable()
export class FlamingoMessageService {

    constructor(private snackBar: MatSnackBar) {
    }

    public showMessage(message: string, action: string = 'OK', duration: number = 3000): void {
        this.snackBar.open(message, action, {
            duration: duration,
            horizontalPosition: 'center',
            verticalPosition: 'top',
        });
    }

    public showError(message: string, action: string = 'OK', duration: number = 5000): void {
        this.snackBar.open(message, action, {
            duration: duration,
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: ['error-snackbar']
        });
    }

    public showSuccess(message: string, action: string = 'OK', duration: number = 3000): void {
        this.snackBar.open(message, action, {
            duration: duration,
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: ['success-snackbar']
        });
    }
}
